<template>
    <div v-if="visible" class="modal-overlay">
        <div class="modal-content">
            <h3>{{ message }}</h3>
            <div class="modal-actions">
                <button @click="confirm" class="btn-confirm">{{ confirmText }}</button>
                <button @click="cancel" class="btn-cancel">{{ cancelText }}</button>
            </div>
        </div>
    </div>
</template>
  
<script setup>
import { ref } from "vue";

const props=defineProps({
    defaultMessage: {type: String, default: "Confirma operação?",},
    defaultConfirmText: {type: String, default: "Sim",},
    defaultCancelText: {type: String, default: "Não",},
})

const visible = ref(false);
const message = ref(props.defaultMessage);
const confirmText = ref(props.defaultConfirmText);
const cancelText = ref(props.defaultCancelText);
const resolvePromise = ref(null);

const show = (customOptions = {}) => {
    message.value = customOptions.message || props.defaultMessage;
    confirmText.value = customOptions.confirmText || props.defaultConfirmText;
    cancelText.value = customOptions.cancelText || props.defaultCancelText;
    visible.value = true;
    return new Promise((resolve) => {
        resolvePromise.value = resolve;
    });
};

const confirm = () => {
    visible.value = false;
    if (resolvePromise.value) resolvePromise.value(true);
};

const cancel = () => {
    visible.value = false;
    if (resolvePromise.value) resolvePromise.value(false);
};

defineExpose({show,});
</script>
  
<style scoped>
.modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
}
.modal-content {
    background: white;
    padding: 20px;
    border-radius: 8px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
    text-align: center;
}
.modal-actions {
    margin-top: 15px;
    display: flex;
    justify-content: center;
    gap: 10px;
}
.btn-confirm,
.btn-cancel {
    padding: 10px 20px;
    border: none;
    border-radius: 4px;
    cursor: pointer;
}
.btn-confirm {
    background-color: #28a745;
    color: white;
}
.btn-cancel {
    background-color: #dc3545;
    color: white;
}
</style>  